import React, { useEffect, useState } from 'react';
import { QuestionnaireBlock } from '@coog/react-components';
import PropTypes from 'prop-types';
import { get, isEqual, reduce } from 'lodash-es';
import Action from './Action.presentational';

const GeneralDataPresentational = ({
  blockGeneralData,
  isFinishedSalesRoute,
  partialUpdateSalesRouteAnswers,
  strings,
  cancelSalesRoute,
  putOnHoldSalesRoute,
  editField,
  willResetForm,
  onResetForm,
  willSaveForm,
  onSaveForm,
  noSaveNotValid,
  i18n,
}) => {
  // generalDataBlock
  const [isValidBlock, setIsValidBlock] = useState(false);
  const [answersBlock, setAnswersBlock] = useState();

  // console.log('answersBlock', answersBlock);

  const handleChangeIsValidGeneralDataBlock = isValidLocal => {
    if (isValidLocal !== isValidBlock) {
      setIsValidBlock(isValidLocal);
    }
  };

  const handleChangeAnswersGeneralDataBlock = answersLocal => {
    if (!isEqual(answersLocal, answersBlock)) {
      setAnswersBlock(answersLocal);
    }
  };

  const handleEditField = (answersLocal, id) => {
    if (answersBlock) {
      if (answersBlock && !isEqual(answersLocal, answersBlock)) {
        editField();
      }
    }
  };

  const checkIsValid = reduce(isValidBlock, (acc, isValid) => acc && isValid, true);

  /**
   * check disable next button
   */
  const checkDisableNextButton = () => {
    let disableNextButton;
    if (isFinishedSalesRoute) {
      disableNextButton = true;
    } else {
      disableNextButton = !checkIsValid;
    }
    return disableNextButton;
  };

  useEffect(() => {
    if (willSaveForm) {
      if (checkIsValid) {
        partialUpdateSalesRouteAnswers({ answers: answersBlock, saveOnly: true })();
        onSaveForm();
      } else {
        noSaveNotValid();
      }
    }
  }, [willSaveForm]);

  // label Button
  const labelNextButton = get(strings, 'editsalesroute.action.button.nextstep.label', 'Etape Suivante');
  const labelCancelButton = get(strings, 'editsalesroute.action.button.cancel.label', 'Annuler');
  const labelPutonholdButton = get(strings, 'editsalesroute.action.button.putonhold.label', 'Mettre en attente');

  return (
    <>
      <QuestionnaireBlock
        questionnaire={blockGeneralData}
        eventEmitter={event => {
          handleChangeIsValidGeneralDataBlock(get(event, 'isValid'));
          handleChangeAnswersGeneralDataBlock(get(event, 'answers'));
          handleEditField(get(event, 'answers'));
        }}
        strings={strings}
        willResetForm={willResetForm}
        onResetForm={onResetForm}
        i18n={i18n}
      />
      <Action
        isDisabledNextButton={checkDisableNextButton()}
        partialUpdateSalesRoute={partialUpdateSalesRouteAnswers({ answers: answersBlock })}
        cancelSalesRoute={cancelSalesRoute}
        putOnHoldSalesRoute={putOnHoldSalesRoute}
        labelNextButton={labelNextButton}
        labelCancelButton={labelCancelButton}
        labelPutonholdButton={labelPutonholdButton}
      />
    </>
  );
};

GeneralDataPresentational.propTypes = {
  blockGeneralData: PropTypes.object.isRequired, // eslint-disable-line
  isFinishedSalesRoute: PropTypes.bool, // eslint-disable-line
  partialUpdateSalesRouteAnswers: PropTypes.func.isRequired,
  cancelSalesRoute: PropTypes.func.isRequired,
  putOnHoldSalesRoute: PropTypes.func.isRequired,
  strings: PropTypes.objectOf(PropTypes.string),
  editField: PropTypes.func.isRequired,
  willResetForm: PropTypes.bool,
  onResetForm: PropTypes.func,
  willSaveForm: PropTypes.bool,
  onSaveForm: PropTypes.func,
  noSaveNotValid: PropTypes.func,
  i18n: PropTypes.object,
};

GeneralDataPresentational.defaultProps = {
  isFinishedSalesRoute: false,
  strings: {},
  willResetForm: false,
  onResetForm: () => {},
  willSaveForm: false,
  onSaveForm: () => {},
  noSaveNotValid: () => {},
  i18n: {},
};

export default GeneralDataPresentational;
